// FileUploader.tsx
import {ref, uploadBytesResumable} from 'firebase/storage';
import {useState} from 'react';
import Button from "react-bootstrap/Button";
import ProgressBar from  "react-bootstrap/ProgressBar"
import '../App.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import {FirebaseStorage} from 'firebase/storage'
import {doc, setDoc, getDoc} from 'firebase/firestore'
import {db} from "../firebase_setup/firebase"
import UploadTask from "firebase/storage";

export const FileUploader = ({storage, files,festivalName, fetchData}: { storage: FirebaseStorage, files: FileList | undefined, festivalName : string, fetchData: () => Promise<void> }) => {

    const [percent, setPercent] = useState(0);

    let progress = 0;


    const progressMap: Map<string, number> = new Map();


    // Reference:
    // https://stackoverflow.com/questions/71153265/how-can-i-upload-multiple-images-in-firebase-v9-cloud-storage-using-reactjs
    const uploadFiles = () => {
        const promises : UploadTask.UploadTask[] = [];
        if (festivalName === "") {
            alert("Please select a festival!");
            return;
        }
        if (files) {
            const date = new Date();
            let dateString = `-${date.getFullYear()}`;
            if (festivalName === "Normal Sabha") {
                dateString += `-${date.getMonth() + 1}`;
            }
            const fireStoreRef = doc(db,'Festivals',`${festivalName}${dateString}`);

            getDoc(fireStoreRef).then((ref) => {
                if(!ref.exists()){
                    console.log('does not exist');
                    //By default, display new pictures
                    setDoc(fireStoreRef, {active: true}).then(() => {
                        console.log('Now we added it!');
                    })
                } else {
                    console.log('already exists');
                }
            }).catch((err) => {
                console.log(err);
            });
            for (let i: number = 0; i < files?.length; ++i) {
                const storageRef = ref(storage, `/images/${festivalName}${dateString}/${files[i].name}`);
                const uploadTask = uploadBytesResumable(storageRef, files[i])
                promises.push(uploadTask)
                uploadTask.on(
                    "state_changed",
                    // eslint-disable-next-line no-loop-func
                    (snapshot) => {
                        const percent: number = Math.round(
                            (snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                        progressMap.set(snapshot.ref.name, percent);
                        progress = 0;
                        progressMap.forEach((value) => {
                            progress += value;
                        });
                        setPercent(progress / progressMap.size)
                    },
                    (error) => console.log(error)
                )
            }
            Promise.all(promises)
                .then(() => {
                    alert("All images uploaded");
                    fetchData().then(() => console.log('called in fileUploader'));
                })
                .then(() => progress = 0)
                .catch(err => console.log(err))
        }
    }


    return (
        <div>
            <div style={{alignItems :'center',
                flex: 'content',
                width : 'auto',
                }}>
                <Button
                    style={{
                    width : '150px'
                    }}
                    onClick={uploadFiles}>

                    Upload Images
                </Button>
                <div style={{
                    display: 'flex',
                    justifyContent : 'center',
                    alignItems : 'center'
                }}>
                        Progress:
                </div>
                <div style={{
                    display: 'flex',
                    justifyContent : 'center',
                    alignItems : 'center'
                }}>
                    <ProgressBar now={percent} label={`${percent.toFixed(0)}%`} style={{width : '300px'}} />
                </div>
            </div>
        </div>
    );
};
